module.exports = __webpack_public_path__ + "media/images/common/cart_btn-4c82bfd5be979897aeb338b3e8e15f9d.gif";